import { render, staticRenderFns } from "./reward-members.vue?vue&type=template&id=22dbf825&"
import script from "./reward-members.vue?vue&type=script&lang=js&"
export * from "./reward-members.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports